@if (buscadorOsm) {
  <div class="buscador-osm-barra">
    <mat-form-field class="buscador-osm" subscriptSizing="dynamic">
      <mat-label>Buscar territorio en OpenStreetMap</mat-label>
      <input
        matInput
        [formControl]="busquedaOsm"
        [matAutocomplete]="autoOsm"
        placeholder="Ej: Palermo, Buenos Aires"
      />
      @if (buscandoOsm()) {
        <mat-spinner matSuffix [diameter]="20"></mat-spinner>
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
      <mat-autocomplete
        #autoOsm="matAutocomplete"
        [displayWith]="mostrarNombreOsm"
        (optionSelected)="seleccionarOsm($event.option.value)"
      >
        @for (r of resultadosOsm; track r.place_id) {
          <mat-option [value]="r">{{ r.display_name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
}

<div #mapContainer class="map-container">
  <div class="flotante">
    <div class="row-flex-start" style="gap: 8px">
      @if (dibujando()) {
        <button
          irxBotonIcono="mapa"
          tono="peligro"
          type="button"
          tooltip="Cancelar dibujo"
          (click)="cancelarDibujo()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (hayGeometria()) {
        <button
          irxBotonIcono="mapa"
          tono="peligro"
          type="button"
          tooltip="Borrar dibujo"
          (click)="borrarDibujos()"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
